<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="bundles"
          :search="search"
        >
          <template #top>
            <v-row>
              <v-col cols="12" md="10">
                <v-text-field v-model="search" label="Suche">
                  <v-icon slot="append">
                    mdi-magnify
                  </v-icon>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="2" class="d-flex justify-end mt-3">
                <v-btn
                  color="primary"
                  @click="createBundlePrompt = true"
                >
                  Hinzufügen
                </v-btn>
              </v-col>
            </v-row>
          </template>
          <template #[`item.actions`]="{ item }">
            <Inertia-Link :href="route('bundle.edit', item.id)">
              <v-icon small>
                mdi-pencil
              </v-icon>
            </Inertia-Link>

            <v-icon @click="deletePrompt(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog v-model="createBundlePrompt" max-width="1000">
      <CreateBundle :taxes="taxes" @updated="updated" />
    </v-dialog>
    <v-dialog v-model="deleteBundlePrompt" max-width="400">
      <v-card>
        <v-card-title class="text-h5">
          Sind Sie sicher dass dieses Item entfernt werden soll?
        </v-card-title>

        <v-card-text> Item: {{ selectedItem.name }} </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="green darken-1"
            text
            @click="deleteBundlePrompt = false"
          >
            Disagree
          </v-btn>

          <v-btn color="red darken-1" text @click="softDelete()">
            Agree
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'
import CreateBundle from '@/Components/Admin/Bundle/Create'

export default {
   name: 'BundleIndex',
   metaInfo () {
      return {
         title: this.title ? this.title : 'Bundle Übersicht',
      }
   },
   components: {
      CreateBundle,
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      bundles: {
         type: Array,
         required: true,
      },
      taxes: {
         type: Array,
         required: true,
      },
   },
   data () {
      return {
         headers: [
            { text: 'Name', value: 'name' },
            { text: 'Prozent', value: 'percent' },
            { text: 'Erstellt am', value: 'created_at' },
            { text: 'Aktionen', value: 'actions', sortable: false },
         ],
         selectedItem: {
            id: null,
            name: '',
         },
         search: null,
         createBundlePrompt: false,
         deleteBundlePrompt: false,
      }
   },
   methods: {
      deletePrompt (item) {
         this.selectedItem = item
         this.deleteBundlePrompt = true
      },
      updated () {
         this.createProductPrompt = false
      },
   },
}
</script>
